module.exports = __webpack_public_path__ + "static/media/achesoothe-3.747e0970.png";